import { useTranslation } from 'react-i18next'

import {
  ProfileBuildingGroupsWidgetItem,
  Widget,
  WidgetContentItemsList,
} from '../../../Widget'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import { getBuildingGroupListItemProps } from './RequestProfileWidgetBuildingGroups.utils'

import * as styles from './RequestProfileWidgetBuildingGroups.module.css'

function RequestProfileWidgetBuildingGroups({ buildingGroups, isSkeleton }) {
  const { t } = useTranslation()

  return (
    <Widget
      contentContainerProps={{
        className: styles.buildingGroupsContent,
      }}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.BUILDING_GROUPS}
      title={t('Widget.BuildingGroupsTitleKey')}
    >
      <WidgetContentItemsList
        Item={ProfileBuildingGroupsWidgetItem}
        getItemPropsFromValue={getBuildingGroupListItemProps}
        items={buildingGroups}
        title={t('Widget.BuildingGroupsListTitleKey', {
          count: buildingGroups?.length,
        })}
        titleWrapperClassName={styles.itemsListTitleWrapper}
      />
    </Widget>
  )
}

export default RequestProfileWidgetBuildingGroups
